import styled, { Interpolation } from 'styled-components';

type props = {
	styles?: Interpolation<React.CSSProperties>
	fullScreenEnabled?: boolean;
	isParentSQ?: boolean;
}

export const RightSidePanel = styled.div<props>`
		height: auto;
		text-align: left;
		position:relative;
		margin-left:0;
		// background: #f3f5f8;
		background: var(--modalSidebarBG);
		// background: var(--defaultBgColor);
		padding:0;
		margin: 0;

		.save-btn{
			width: 100%;
			font-size: 1.125rem;
			line-height: 1.4;
			cursor:pointer!important;
			padding: 0.5em 1.85rem;
			margin:0;
			display:flex;
			justify-content:center;
			align-items:center;
			gap:0.5em;
			margin-top:20px;
			color: var(--textHeadingColor);
			width: 100% !important;
			padding: 0.5em 2rem 0.5em;
				@media (min-width: 1023px) and (max-width: 1399px) and (max-height: 900px) {
					margin-top:10px;
				}
			
			svg{
				position: absolute;
				right: 16px;
				top:15px;
			}
			@media (max-width:980px){
				max-width: 100%;
				margin:0 auto;
				width:calc(100% - 2rem) !important;
				// display:none;
				margin-top: 12px;
				// width: 96%;
				border-radius:1px
			}
			@media (max-width:500px){
					max-width: 100%;
					width: 93%;
			}
		:disabled{
			cursor: not-allowed!important;
			opacity: 50%
		}
		}


		& .toggleModeFullscren{
					&.toggleMinizedBtn {
						background: var(--defaultBgColor);
						border: none;
						padding: 6px;
    				border-radius: 0px 17px 17px 0px;
						position: fixed;
						left:0;
						top:10.5%;
						z-index:2;

						svg{
							 transition: transform 0.3s ease-in-out; /* smooth */
						}
						&:hover{
							opacity: 1;
							background: var(--defaultBgLightColor);
							box-shadow: 0 4px 10px rgba(0,0,0,0.3);
							 svg{
							  transform: translateX(3px);
							 }
						}
					}		
			}
`;

export const PanelDetailDiv = styled.div<props>`
	display:flex;
	justify-content:space-between;
	padding:${(props) => (props.fullScreenEnabled ? '0px' : '0.6rem 1rem')} ;
	background: transparent;
	gap:.75rem;
	flex: 1;

	@media(max-width: 440px){
			gap:.35rem;
	}

	&:not(:last-child){
		margin-bottom:0.25rem;
	}

	&.environment-details{
		h2{
			font-size:0.8rem;
		}
		h4{
			font-size:0.9rem;
		}
	}
		
		&.total-gutter-area-wrap-mob{
				padding:${(props) => (props.fullScreenEnabled ? '0px' : '0.6rem 0')} ;
		}

	@media (max-width: 540px)	{
		padding:${(props) => (props.fullScreenEnabled ? '0px' : '0.6rem 1rem 0.25rem')} ;
	}

	@media (max-width: 640px){
		flex-wrap:wrap;
	}


	&.design-mode-panel{
		padding-bottom: 0px;
		padding-top: 1rem; 
		flex-direction: column;
		gap:.15rem;
	}	

	&.b2C-roof-attrs{
	  padding: 0.125rem 1rem 0.125rem;
	}
	.react-change-panel__control{
		border-radius: 8px;
		font-size:14px;
		background: var(--defaultBgLightColor);
		border-color: var(--borderLightColor);
	}
	.react-change-panel__single-value{
		color: var(--textColor);
	}		
`;

export const SQMobileViewWrap = styled.div`
display:grid;
grid-template-columns: 50% 50%;

	&.roof-attrs{
		display: flex;
		justify-content: space-between;
		padding-top: 8px;
	}

h2 {
	@media (min-width: 980px){
			margin-top:0px
	}
	@media (max-width: 540px) {
  font-size:1rem;
  }
	margin-bottom:0px;
	margin-top:0px
 }
	@media (max-width: 769px) {
	grid-template-columns: 70% 30%;
	}
	.widthAuto{
		width:100%
	}
	@media (max-width: 540px) {
	grid-template-columns: 60% 40%;
	}
	@media (max-width: 420px) {
	display:flex;
	flex-direction:column;
	}
  .paddingcustom{
  @media (max-width: 420px) {
    padding: 0rem 1rem 1rem 1rem;
 	}
}
`;

export const MobileViewWrap = styled.div`
	padding-bottom: 10px;

	&.roof-sm-screen{
		padding-bottom: 20px;
	}

	.annual-usage-title h4,
	.electric-bill-title h4,
	.change-panel-title h4{
		// min-width: 96px;
	}
	.electric-bill-title input,
	.annual-usage-title input{
		padding: 0.563rem 0.65rem;
    line-height: 1.35;
	}
	.change-panel-wrap{
		padding: 0rem 1rem
	}	
	.bill-annual-wrap{
		margin-bottom: 0;
	}	
	
	button.save-btn.ipad-save-btn {
			width: calc(100% - 2rem) !important;
    	margin: 12px auto 0;
	}	
`;

export const DivSolarImagery = styled.div`
	display: flex;
  width: 100%;
	padding-top: 3px;
	justify-content: space-between;
`;

// export const DivLabel = styled.div`
// 	    display: flex;
//     	align-items: center;
//     	gap: 6px;
// 			color: rgb(46, 56, 77);
// 			font-family: Inter;
// 			font-size: 1rem;
// 			font-weight: 600;
// 			margin-bottom: 0;

// 			@media (max-width: 1339px){
// 			 font-size: 0.95rem;

// 			 svg{ width: 18px; height: 18px}
// 			}

// 			&.roof-attr-label{
// 				font-weight: 400;
// 			}
// `;
// export const DivValue = styled.div`
// 			display: flex;
//     	align-items: center;
//     	gap: 5px;
// 			font-family: Inter;
// 			color:rgb(46, 56, 77);
//     	font-size: .9rem;
// 			line-height:20px;
//     	font-weight: 500;

// 			@media (max-width: 1339px){
// 			 font-size: 0.85rem;

// 			 svg{ width: 18px; height: 18px}
// 			}

// 			&.roof-attr-value{
// 				color: var(--primary);
// 				font-size: 1.125rem;
//     		font-weight: 600;
// 			}
// `;

export const SideModalArrowbutton = styled.div`
		position: absolute;
		left: 0px;
		right: 0px;
		top: -20px;
		z-index: 10;
		width: 32px !important;
		height: 32px !important;
		display: flex;
		justify-content: center;
		margin: 0 auto;
		transition: transform 0.3s ease-in-out;	

		&.sidepanel-model-close{
			top: 2px;
		}
`;

export const DivSidePanelWrap = styled.div`
	min-height: 46px;
	display: flex;
	justify-content: flex-start;
	width: 100%;
	align-items: center;
`;

export const PanelDetailDefaultView = styled.div`
	display: flex;
	flex: 1;
	justify-content:space-between;
	background: var(--surfaceLightColor);
	padding: 10px 10px 8px;
	gap: 8px;
	position: relative;
	flex-wrap: wrap;

	.roof-attr-wrap{
			> div{
					line-height: 20px;
					font-size: 1rem; 
			}
	}
	
	> div {
			width: auto;
			padding-right:0;
			gap: 0.35rem;
			h2,h4{
				margin:0;
				line-height: 19px;
				font-size: 0.938rem;
			}
		}


	 button{
	 	background: none;
		border: none;
		padding: 0px;
		position: relative;
		top: 2px;
		transition: transform 0.3s ease-in-out;		
		&:hover{
			 transform: translateY(-2px);
		}
	 }

`;

export const EditModeEnabledwrap = styled.div`
		display: flex;
    justify-content: space-between;
    width: 100%;
		gap: 8px;
		flex-wrap: wrap;

		> div{
			width: auto !important; 
		}

		@media (max-width: 560px){
			gap: 12px;
			> div{
				width: 100% !important; 
			}
		}
	
`;